export default __webpack_public_path__ + "static/media/Eye_4_M_C2.1230c88e.svg";